<template>
  <v-select
    :model-value="modelValue"
    :items="items"
    item-title="label"
    item-value="value"
    :label="$t('ncrm.workflows.nodeSettings.externalForms.selectForm')"
    hide-details="auto"
    :menu-props="selectMenuProps"
    @update:model-value="$emit('update:modelValue', $event)"
  >
    <template #item="{ props: itemProps, item }">
      <v-list-item v-bind="itemProps">
        <template #append>
          <v-chip size="x-small" :color="PRIVACY_STATUS_COLORS[item.raw.privacyStatus]">
            {{ $t(`ncrm.workflows.nodeSettings.externalForms.privacy.status.${item.raw.privacyStatus}`) }}
          </v-chip>
        </template>
      </v-list-item>
    </template>
  </v-select>
</template>

<script>
import { PRIVACY_STATUS_COLORS } from "@/Utile/ncrmExternalFormPrivacy.mjs";

// Selectorul formularelor din `Forme externe`, cu badge-ul Privacy salvat al
// fiecărui formular (S5.1): `Configurat`, `Privacy incomplet` sau `Privacy neconfigurat`.
export default {
  name: "NcrmWorkflowExternalFormPicker",
  props: {
    modelValue: { type: [Number, String], default: null },
    widgets: { type: Array, default: () => [] },
    selectMenuProps: { type: Object, default: () => ({}) },
  },
  emits: ["update:modelValue"],
  data: () => ({ PRIVACY_STATUS_COLORS }),
  computed: {
    items() {
      return this.widgets.map((widget) => ({
        value: widget.id,
        label: `${widget.name || widget.form_key} · ${widget.status}`,
        privacyStatus: widget.privacy_status || "unconfigured",
      }));
    },
  },
};
</script>
